import Button from './Button.vue';
import ShareButton from './ShareButton.vue';
import { WorkShopButton } from './type';

Button.Share = ShareButton;

export { WorkShopButton }
export default Button;
